import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ConfirmProvider } from './lib/confirm';
import { Toaster } from './lib/toast';
import AppRoutes from './routes/index';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ConfirmProvider>
          <AppRoutes />
        </ConfirmProvider>
        <Toaster />
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
